/* eslint-disable no-underscore-dangle */
import { Container, Grid } from '@material-ui/core';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomListView from 'src/components/customTable/CustomListView';
import SimpleBreadCrumb from 'src/components/widgets/BreadCrumb/SimpleBreadCrumb';
import SearchBar from 'src/components/widgets/searchBar/SearchBar';
import useSettings from 'src/hooks/useSettings';
import { fetchAllInvoices } from 'src/store/slices/omsSlice';
import { AppDispatch } from 'src/store/store';
import { formatDate } from 'src/utils/formatDate';
import setTitle from 'src/utils/setTitle';

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    btn: {
      width: '47px',
      height: '30px',
      padding: 0,
      minWidth: 'initial',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '4px',
      color: '#fff',
      marginLeft: '13px',
      '& .MuiButton-iconSizeMedium': {
        margin: '0',
      },
    },
    activeButton: {
      background: 'rgba(7, 83, 0, 0.1)',
      color: 'rgba(29, 122, 21, 1)',
      width: '100px',
    },
    inActiveButton: {
      background: 'rgba(255, 161, 161, 0.3)',
      color: 'red',
      width: '100px',
    },
    tabs: {
      '& .MuiTab-root': {
        backgroundColor: 'transparent',
        minWidth: '120px',
      },
      '& .Mui-selected': {
        backgroundColor: '#231F20',
        color: '#fff',
      },
    },
  })
);

interface OrderUser {
  _id: string;
  name: string;
}

interface OrderProduct {
  _id: string;
  name: string;
}

interface OrderClient {
  _id: string;
  name: string;
}
interface Order {
  _id: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  createdBy: OrderUser;
  updatedBy: OrderUser;
  createdAt: string;
  updatedAt: string;
  product: OrderProduct;
  client: OrderClient;
}

const InvoiceListing = () => {
  setTitle('ERP | Order Management System');
  const classes = useStyles();

  const dispatch = useDispatch<AppDispatch>();
  const { settings } = useSettings();

  const allInvoices = useSelector((state: any) => state.oms.allInvoices);
  const [totalCount, setTotalCount] = useState<number>(0);

  const [page, setPage] = useState<any>(
    JSON.parse(localStorage.getItem('omsOrderPg'))?.pageNo || 0
  );
  const [pageSize, setPageSize] = useState<any>(
    JSON.parse(localStorage.getItem('omsOrderPg'))?.pageLimit || 25
  );
  const [search, setSearch] = useState<string>(
    JSON.parse(localStorage.getItem('omsOrderPg'))?.search || ''
  );
  const [selectedSort, setSelectedSort] = useState<any>(
    JSON.parse(localStorage.getItem('omsOrderPg'))?.sortColumn || {
      id: '',
      value: 'asc',
    }
  );
  const navigate = useNavigate();
  const handleNavigate = (data) => {
    // setRowData(data);
    // setEditFormOpened(true);
    navigate(`/oms/invoices/${data._id}`);
  };

  const columns = [
    // { id: 'productSKU', label: 'SKU' },
    // {
    //   id: 'status',
    //   label: 'Invoice Status',
    //   // Cell: (val, row) => StatusCellRenderer(val, row),
    // },
    // { id: 'name', label: 'Order ID', Cell: (val, row) => row.product?.name },
    {
      id: 'orderId',
      label: 'Order ID',
      Cell: (val, row) => row?.orderId,
    },
    {
      id: '_id',
      label: 'Invoice ID',
      Cell: (val, row) => row?._id,
    },
    {
      id: 'createdBy',
      label: 'Created By',
      Cell: (val, row) => row?.createdBy?.name,
    },
    {
      id: 'billedTo',
      label: 'Bill To',
      Cell: (val, row) => row?.billedTo?.name,
    },
    {
      id: 'invoiceDate',
      label: 'Invoice Date',
      Cell: (val, row) => formatDate(row?.invoiceDate),
    },
    {
      id: 'tax',
      label: 'Tax',
      Cell: (val, row) => row?.tax,
    },
    {
      id: 'discount',
      label: 'Discount',
      Cell: (val, row) => row?.discount,
    },
    {
      id: 'totalPrice',
      label: 'Total Price',
      Cell: (val, row) => row?.totalPrice,
    },
  ];

  const handleGetAllOrders = () => {
    const apiPayload = {
      page,
      pageSize,
      search,
      column: selectedSort?.id || 'defaultSort',
      sort: selectedSort?.value === 'asc' ? '1' : '-1',
    };
    const omsInvoicePage = {
      pageLimit: pageSize,
      pageNo: page,
      search,
      sortColumn: selectedSort,
    };
    localStorage.setItem('omsInvoicePage', JSON.stringify(omsInvoicePage));
    const keys = Object.keys(apiPayload);
    const values = Object.values(apiPayload);
    // Create an array to store the non-empty key-value pairs
    const queryParams = [];
    for (let i = 0; i < values.length; i++) {
      if (values[i] !== '' && values[i] !== null && values[i] !== undefined) {
        queryParams.push(`${encodeURIComponent(keys[i])}=${values[i]}`);
      }
    }
    const queryString = queryParams.join('&');
    dispatch(fetchAllInvoices(`${queryString}`)).then((res) => {
      setTotalCount(res?.payload?.totalRecords || 0);
    });
  };

  const handleSearch = (val) => {
    setSearch(val);
  };
  // Open create drawer if #create is in the URL

  // useEffect(() => {
  //   dispatch(getAllClients());
  //   // dispatch(getAllProducts());
  // }, []);
  useEffect(() => {
    handleGetAllOrders();
  }, [page, pageSize, search, selectedSort]);
  const BreadCrumbsData = {
    title: 'Invoices',
    // links: [
    //   {
    //     name: 'catalogues',
    //     to: '/pim/catalogues',
    //   },
    //   {
    //     name: `${catalogueName}`,
    //     to: `/pim/catalogues/${catalogueName}`,
    //   },
    //   {
    //     name: `${categoryName?.name}`,
    //     to: `/pim/catalogues/${catalogueName}`,
    //   },
    // ],
  };
  return (
    <Container
      maxWidth={settings.compact ? 'xl' : false}
      sx={{
        py: 4,
      }}>
      <Grid container justifyContent="space-between" spacing={3}>
        <Grid
          item
          sx={{
            mb: 1,
          }}>
          <Grid item md={12}>
            <SimpleBreadCrumb data={BreadCrumbsData} />
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            // justifyContent: 'flex-end',
            gap: '10px',
          }}>
          <SearchBar
            onSearch={handleSearch}
            value={search}
            placeholderData="Search"
          />
        </Grid>
      </Grid>
      <CustomListView
        onRowClick={handleNavigate}
        columns={columns}
        data={allInvoices || []}
        page={page}
        pageSize={pageSize}
        setPageSize={setPageSize}
        setPage={setPage}
        count={totalCount}
        selectedSort={selectedSort}
        setSelectedSort={setSelectedSort}
      />
    </Container>
  );
};

export default InvoiceListing;
